/**
 * True when the page is being driven by a browser under automation control.
 *
 * This guards our own test runs rather than defending against crawlers: a bot that
 * wants to hide simply clears the flag. Its value is that it holds wherever the suite
 * points — today Cypress runs against localhost, where no Umami site is configured, so
 * nothing reaches production by accident rather than by design. Aim a run at staging or
 * production and that accident ends silently, with no failing test to say so.
 *
 * Guarded for the server, where `Metadata` also renders and `navigator` does not exist.
 */
export const isAutomatedBrowser = (): boolean => typeof navigator !== 'undefined' && navigator.webdriver === true;
